import React from 'react';
import SectionHeader from './SectionHeader';
import PreviousClientBox from './PreviousClientBox';
import SectionFooter from './SectionFooter';
import './SectionPreviousClients.css';

class SectionPreviousClients extends React.Component {
  render() {
    const {sectionHeader, sectionFooter, items} = this.props.previousClientsData;

    return (
      <section id='previous-clients'>
        <SectionHeader item={sectionHeader}/>
        <div className='row'>
          {items.map((clientData, index) => <PreviousClientBox data={clientData} key={index}/>)}
        </div>
        <SectionFooter footerText={sectionFooter}/>
      </section>
    )
  }
}

SectionPreviousClients.propTypes = {
  previousClientsData: React.PropTypes.object.isRequired
}

export default SectionPreviousClients;



// WEBPACK FOOTER //
// ./src/components/SectionPreviousClients.js